/**
 * Cấu hình phân trang mặc định cho toàn bộ ứng dụng.
 */
export const DEFAULT_PAGE = 1;
export const DEFAULT_PAGE_SIZE = 10;
